
import { Component, Vue } from "vue-property-decorator";
import { BRow, BCol, BCard, BCardGroup, BCardTitle } from "bootstrap-vue";
@Component({
  components: {
    BRow,
    BCol,
    BCard,
    BCardGroup,
    BCardTitle,
  },
})
export default class InPractiseEvent extends Vue {}
